import React from 'react'
import { DcButton, DcInput, PixelFactoryContext, PixelTable } from 'pixel-base'
import styled from 'styled-components'

import { updateAddress } from 'utils/api-routes.util'

import SelectCity from './SelectCity'
import { OrderSummary } from '../../../../decl'
import { IPixelFactory } from '../../../../decl.d'

interface IProps {
  handleClearRows: () => void
  refresh: () => void
  selectedOrders: OrderSummary[]
  cities: {
    name: string
  }[]
  handleClose: () => void
}
const OrdersUpdateShippingInfo = (props: IProps) => {
  const { showSuccess, hidePageLoader, showPageLoader, pixelConfirm } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { handleClearRows, refresh, selectedOrders, cities } = props

  const [data, setData] = React.useState(selectedOrders)
  const columns = [
    {
      name: 'NO',
      selector: (row) => row.source_order_id,
    },
    {
      name: 'Name',
      selector: (row) =>
        `${row.shipping?.first_name} ${row.shipping?.last_name}`,
    },
    {
      name: 'City',
      style: {
        'div:first-child': {
          overflow: 'visible !important',
        },
      },
      selector: (row) => (
        <SelectCity
          cities={cities}
          value={row?.shipping?.city}
          id={row?.number}
          setData={setData}
          data={data}
          bulkEdit={true}
          placeholder={'Search City'}
        />
      ),
    },
    {
      name: 'Phone',
      selector: (row) => (
        <>
          <DcInput
            isShowLabel={false}
            value={row.shipping?.phone}
            onChange={(e) => {
              const newData = data.map((item) => {
                if (item.number === row.number) {
                  item.shipping.phone = e.target.value
                }
                return item
              })
              setData(newData)
            }}
          />
        </>
      ),
    },
    {
      name: 'Address',
      selector: (row) => row.shipping.address1,
    },
  ]

  const invalidCities = () => {
    return data.filter((item) => {
      const city = cities.find((city) => {
        return city.name.toLowerCase() === item.shipping.city.toLowerCase()
      })
      return !city
    })
  }
  const handleUpdate = () => {
    if (invalidCities()?.length > 0) {
      pixelConfirm({
        title: 'Invalid Cities',
        message:
          'There are invalid cities that may cause consignment to fail. Are you sure you want to continue?',
        onConfirm: () => {
          updateData()
        },
      })
    } else {
      updateData()
    }
  }
  const updateData = () => {
    const obj = {
      customers: data.map((item) => {
        return {
          order_id: item.number,
          city: item.shipping.city,
          phone: item.shipping.phone,
        }
      }),
    }
    showPageLoader()
    updateAddress(obj).subscribe(() => {
      showSuccess('Updated successfully.')
      handleClearRows()
      refresh()

      props.handleClose()
      hidePageLoader()
    })
  }
  return (
    <>
      <PixelTable
        dense
        pagination={false}
        columns={columns}
        data={data}
        fixedHeader
        fixedHeaderScrollHeight="70vh"
      />

      <UpdateButtonContainer>
        <DcButton onClick={handleUpdate}>Update</DcButton>
      </UpdateButtonContainer>
    </>
  )
}

const UpdateButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`

export default OrdersUpdateShippingInfo
